module.exports = __webpack_public_path__ + "static/media/Country-Club-Village-PhaseIII-Master-Deed.60339311.pdf";